import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const actions = createActions(
  {
    TELEPHONY_GET_USERS_BY_QUERY: [
      (payload) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_GET_ALL_OWN_NUMBERS: [
      (payload) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_RENEW_TOKEN: [
      (payload) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_SET_HOLD: [
      (payload) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_SET_MUTE: [
      (payload) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_GET_ALL_COUNTRY_CODES: [
      (payload) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_GET_QUERY_NUMBERS: [
      (payload) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },

  'TELEPHONY_GET_USERS_BY_QUERY_SUCCEEDED',
  'TELEPHONY_GET_USERS_BY_QUERY_FAILED',

  'TELEPHONY_GET_ALL_COUNTRY_CODES_SUCCEEDED',
  'TELEPHONY_GET_ALL_COUNTRY_CODES_FAILED',

  'TELEPHONY_RESET_USERS',

  'TELEPHONY_GET_ALL_OWN_NUMBERS_SUCCEEDED',
  'TELEPHONY_GET_ALL_OWN_NUMBERS_FAILED',

  'TELEPHONY_GET_QUERY_NUMBERS_SUCCEEDED',
  'TELEPHONY_GET_QUERY_NUMBERS_FAILED',

  'TELEPHONY_RENEW_TOKEN_SUCCEEDED',
  'TELEPHONY_RENEW_TOKEN_FAILED',

  'TELEPHONY_SET_BLOCKED',

  'TELEPHONY_OPEN_DROPDOWN',
  'TELEPHONY_CLOSE_DROPDOWN',

  'TELEPHONY_SET_HOLD_SUCCEEDED',
  'TELEPHONY_SET_HOLD_FAILED',

  'TELEPHONY_SET_SEARCH_VALUE',

  'TELEPHONY_SET_MUTE_SUCCEEDED',
  'TELEPHONY_SET_MUTE_FAILED',

  'TELEPHONY_RESET_HOLD',

  'TELEPHONY_CHANGE_FROM_NUMBER',

  'TELEPHONY_SET_ACTIVE_CALL_TOKEN_REGION',

  'TELEPHONY_SET_FROM_NUMBER_INITIALIZATION_STATUS',
);
